export const NewDropdownCard = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 7.82843L20 19C20 20.6569 18.6569 22 17 22L7 22C5.34315 22 4 20.6569 4 19L4 5C4 3.34315 5.34315 2 7 2L14.1716 2C14.9672 2 15.7303 2.31607 16.2929 2.87868L19.1213 5.70711C19.6839 6.26972 20 7.03278 20 7.82843ZM18 19L18 7.82843C18 7.56321 17.8946 7.30886 17.7071 7.12132L14.8787 4.29289C14.6911 4.10536 14.4368 4 14.1716 4L7 4C6.44771 4 6 4.44771 6 5L6 19C6 19.5523 6.44771 20 7 20L17 20C17.5523 20 18 19.5523 18 19ZM16 14.5L16 18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18L14 14.5C14 13.9477 14.4477 13.5 15 13.5C15.5523 13.5 16 13.9477 16 14.5ZM15 10C15.5523 10 16 10.4477 16 11L16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12L14 11C14 10.4477 14.4477 10 15 10ZM12 16C12.5523 16 13 16.4477 13 17L13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18L11 17C11 16.4477 11.4477 16 12 16ZM12 10C12.5523 10 13 10.4477 13 11L13 14.5C13 15.0523 12.5523 15.5 12 15.5C11.4477 15.5 11 15.0523 11 14.5L11 11C11 10.4477 11.4477 10 12 10ZM9 10C9.55229 10 10 10.4477 10 11L10 12C10 12.5523 9.55229 13 9 13C8.44772 13 8 12.5523 8 12L8 11C8 10.4477 8.44772 10 9 10ZM9 13.5C9.55229 13.5 10 13.9477 10 14.5L10 18C10 18.5523 9.55229 19 9 19C8.44772 19 8 18.5523 8 18L8 14.5C8 13.9477 8.44772 13.5 9 13.5Z'
        fill='#200000'
      />
    </svg>
  );
};
